import { render } from "./perfil.vue?vue&type=template&id=3a1f4a36&scoped=true"
import script from "./perfil.vue?vue&type=script&lang=js"
export * from "./perfil.vue?vue&type=script&lang=js"

import "./perfil.vue?vue&type=style&index=0&id=3a1f4a36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1f4a36"]])

export default __exports__